import React from 'react'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'
import {MBMemberEMailInput} from '../../Atoms/MBMemberEMailInput'
import {ErrorDisplay} from '../../Molecules/ErrorsAndAlert/ErrorDisplay'
import {ContentNotes} from '../../Molecules/BaseContentBlocks/ContentNotes'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {Spacer} from '../../../../Common/Components/Spacer'
import {MBContentSubTitleTypography} from '../../Atoms/Typographies'
import {ColumnFlexContainer} from '../../Atoms/Containers'
import {MBContentBodyDivider} from '../../Atoms/Dividers'

type MailAddressFormProps = {
  title: string
  topMessage: React.ReactNode
  note: string[]
  logoImgUrl?: string
  inputLabel: string
  inputValue: string
  hasErrors: boolean
  errorMessages: string[]
  onMailAddressChange: (mailAddress: string) => void
  onMailAddressBlur: (mailAddress: string) => void
}
export const MailAddressFormContent: React.VFC<MailAddressFormProps> = (props) => {
  return (
    <ContentBlock data-testid={'block-mail-address-input'}>
      <ContentTitle logoUrl={props.logoImgUrl}>{props.title}</ContentTitle>
      <ContentTopMessage>{props.topMessage}</ContentTopMessage>

      <Spacer mb={'18px'} mt={'18px'}>
        <MBContentBodyDivider/>
      </Spacer>

      <Spacer>
        <ColumnFlexContainer gap={'10px'}>
          <label className="mail-address-label" htmlFor="email">
            <MBContentSubTitleTypography>{props.inputLabel}</MBContentSubTitleTypography>
          </label>
          <MBMemberEMailInput
            name="email"
            value={props.inputValue}
            id="email"
            placeholder=""
            hasError={props.hasErrors}
            onChange={(e): void =>
              props.onMailAddressChange(e.target.value)}
            onBlur={(e): void =>
              props.onMailAddressBlur(e.target.value.trim())}
          />
        </ColumnFlexContainer>

        <ErrorDisplay
          errors={props.errorMessages}
        />

        <Spacer mt={'32px'}>
          <ContentNotes notes={props.note}/>
        </Spacer>
      </Spacer>
    </ContentBlock>
  )
}
